var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":"","on-preview":_vm.handlePictureCardPreview,"http-request":_vm.upload,"file-list":_vm.fileLists,"multiple":"","on-remove":_vm.removeFileList}},[_c('div',{staticClass:"uploading"},[_vm._v("附件上传")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }